var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level-stage-container"},[_c('LevelDemo',{attrs:{"levels":_vm.Packets.level}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }